import { useState } from "react";

import DrawerLayout from "client/common/components/stackables/DrawerLayout";
import { useCurrentDrawer } from "client/common/hooks/stackables";

import { useUpdateClientMutation } from "../../hooks";
import { useClientPrimaryContactPreferencesQuery } from "../../../inbox/hooks";
import FetchErrorAlert from "../../../common/components/errors/FetchErrorAlert";
import TextInput from "../../../common/components/inputs/TextInput";

const AccountUpdateCommsEmailDrawer = () => {
  const {
    data: primaryContactPreferences,
    isLoading,
    error,
  } = useClientPrimaryContactPreferencesQuery();
  const { close } = useCurrentDrawer();
  const [emailAddress, setEmailAddress] = useState(
    primaryContactPreferences?.primary_contact_email?.email_address || "",
  );

  const {
    mutate: updateClient,
    isLoading: isUpdating,
    error: updateClientError,
  } = useUpdateClientMutation({ onSuccess: close });

  if (isLoading) {
    return <DrawerLayout.Loading />;
  }

  if (!primaryContactPreferences || error) {
    return <DrawerLayout.FetchError error={error} entityName="account" />;
  }
  const title = "Update communications email";

  return (
    <DrawerLayout>
      <DrawerLayout.Header title={title} onClose={close} />
      <DrawerLayout.Form
        submitText="Update email"
        canSubmit={!isLoading && !isUpdating}
        onSubmit={() => updateClient({ primary_email_address: emailAddress })}
        error={error}
      >
        {!!updateClientError && <FetchErrorAlert error={updateClientError} />}
        <DrawerLayout.Form.Group>
          <TextInput
            value={emailAddress || ""}
            label="Email Address"
            onChange={setEmailAddress}
            errors={updateClientError?.errors.primary_email_address}
          />
        </DrawerLayout.Form.Group>
      </DrawerLayout.Form>
    </DrawerLayout>
  );
};

export default AccountUpdateCommsEmailDrawer;
